import httpRequest from 'httpRequest'
import { BrandContract, BrandStatusContract } from 'models'

const BRAND_PREFIX = 'brands'

const brandService = {
    getBrands: () =>
        httpRequest.get<BrandContract[]>(`/company/${BRAND_PREFIX}`),
    getBrandByID: (brandID: string) =>
        httpRequest.get<BrandContract>(`/company/${BRAND_PREFIX}/${brandID}`),
    createBrand: (payload: BrandContract) =>
        httpRequest.post<BrandContract>(`/company/${BRAND_PREFIX}`, payload),
    updateBrand: (brandID: string, payload: BrandContract) =>
        httpRequest.put(`/company/${BRAND_PREFIX}/${brandID}`, payload),
    deleteBrands: (brandIDs: string[]) =>
        httpRequest.delete(`/company/${BRAND_PREFIX}`, {
            params: { brandIDs },
        }),
    getLocationBrandsStatus: (includeImage: boolean = false) =>
        httpRequest.get<BrandStatusContract[]>(
            `/location/${BRAND_PREFIX}/status`,
            {
                params: { includeImage: includeImage },
            },
        ),
    updateLocationBrandsStatus: (brandID: string, isActive: boolean) =>
        httpRequest.put(
            `/location/${BRAND_PREFIX}/${brandID}/status`,
            {},
            { params: { isActive: isActive } },
        ),
    deleteLocationBrands: (brandIDs: string[]) =>
        httpRequest.delete(`/location/${BRAND_PREFIX}`, {
            params: { brandIDs },
        }),
}

export default brandService
